module.exports = __webpack_public_path__ + "img/shop_plate_PVC.3b5cb3ff.jpg";